module.exports = __webpack_public_path__ + "static/media/vehicle-marker.942007a8.svg";